import { Component, OnDestroy, OnInit, inject } from '@angular/core';
import { Subject, takeUntil } from 'rxjs';
import { ScrollText, LucideAngularModule } from 'lucide-angular';
import { SystemConfigurationService } from '@app/core/api/system-configuration/system-configuration.service';
import { SafeRichTextComponent } from '@app/shared/forms/safe-rich-text/safe-rich-text.component';

@Component({
    selector: 'app-terms-and-conditions',
    standalone: true,
    imports: [LucideAngularModule, SafeRichTextComponent],
    templateUrl: './terms-and-conditions.component.html',
    styleUrls: ['./terms-and-conditions.component.scss'],
})
export class TermsAndConditionsComponent implements OnInit, OnDestroy {
    readonly ScrollText = ScrollText;

    private systemConfigService = inject(SystemConfigurationService);
    private destroy$ = new Subject<void>();

    isLoading = false;
    content = '';

    ngOnInit(): void {
        this.loadTermsAndConditions();
    }

    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
    }

    private loadTermsAndConditions(): void {
        this.isLoading = true;

        this.systemConfigService
            .getSysConfigByKey('terms_and_conditions')
            .pipe(takeUntil(this.destroy$))
            .subscribe({
                next: (response) => {
                    this.isLoading = false;
                    this.content = response.data || '';
                },
                error: (error) => {
                    this.isLoading = false;
                    this.content = '<p>Failed to load terms and conditions. Please try again later.</p>';
                    console.error('Failed to load terms and conditions:', error);
                },
            });
    }
}
